// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const getIsLocalCacheHydrated = propIn(['localCache', 'hydration', 'hydrated']);

export const getLocalCacheHydrationTimestamp = propIn(['localCache', 'hydration', 'hydrationTimestamp']);
